.card {
  width: 43rem;
  height: 14rem;
  margin-top: 2.4rem;
  padding: 2.4rem;
  background-color: var(--color-white);
  border-radius: 2.4rem;
}

.circleIcon {
  transform: rotate(-180deg);
}

.iconRoundContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.8rem;
  height: 1.8rem;
  margin-right: 0.8rem;
  background: var(--color-mabel);
  border-radius: 0.8rem;
}

.cardTitle {
  font-weight: bold;
  font-size: 1.6rem;
  line-height: 1.2;
}

.cardTitleContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 2.4rem;
}

.cardAmount {
  font-weight: bold;
  font-size: 4rem;
  line-height: 1.2;
}

.savingsDetails {
  margin-top: 4rem;
}

.savingsDetailsTitle {
  margin-bottom: 1.6rem;
  font-weight: bold;
  font-size: 1.6rem;
  line-height: 1.2;
}

.taxProfile {
  color: var(--color-semantic-text-neutral20);
}

.taxProfileLink {
  margin-left: 0.4rem;
}

.link:not(.pristine):focus {
  border-radius: 4px;
  outline: 1px solid rgb(var(--color-regent-gray-rgb), 0.5);
}

.loadingAmount {
  height: 4.8rem;
}
